import { ReactElement, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Header, Loader, ScrollToTop } from '@components/common';
import { convertPathNameToTitle } from '@helper/utils';
import { useRouteStoreReset } from '@hooks/useRouteStoreReset';
import { useOverlayStore } from '@store/useOverlaySrote';
import { CheckServiceWorkerUpdates } from './checkServiceWorkerUpdates';
import { useRouteHandler } from '../authGuard';

export const SubRoutingLayout = (): ReactElement => {
	const { pathname: path } = useLocation();
	const { isAuthenticated, permissionAndSessionCheck } = useRouteHandler();
	const isOverlayVisible = useOverlayStore((state) => state.isSidebarOpen || state.isFilterOpen || state.isSortOpen);
	const isFilterOrSortOpen = useOverlayStore((state) => state.isFilterOpen || state.isSortOpen);
	const closeOverlay = useOverlayStore((state) => state.closeOverlay);
	useRouteStoreReset(path);

	if (!isAuthenticated() && path !== '/login') {
		return (
			<Suspense fallback={<Loader />}>
				<Navigate to="/login" replace />
			</Suspense>
		);
	}
	return (
		<>
			<ScrollToTop />
			{isAuthenticated() && <Header subRoute={true} menuHeading={convertPathNameToTitle(path)} />}
			<main>
				<Suspense fallback={<Loader />}>{permissionAndSessionCheck()}</Suspense>
			</main>
			<button
				id="overlay"
				type="button"
				className={`overlay ${isFilterOrSortOpen ? 'overlay-filter' : ''} ${isOverlayVisible ? 'show' : ''}`}
				onClick={closeOverlay}
				onKeyDown={(e) => (e.key === 'Escape' || e.key === 'Enter') && closeOverlay()}
				aria-label="Close overlay"
			/>
			<CheckServiceWorkerUpdates />
		</>
	);
};
